import { PartnerDTO } from 'support/types';
import { AlertSection } from 'components/Display/Alert';
import { Alert } from 'components/Display/Alert/Alert';

import { useOtherPartnerBlockingCopy } from '../hooks/useOtherPartnerCopy';

type Props = {
  isCurrentPartnerReceiver?: boolean;
  senderPartner?: PartnerDTO | null;
  receiverPartner?: PartnerDTO | null;
};

export const OtherPartnerResolverNoActionPreset = ({
  isCurrentPartnerReceiver,
  senderPartner,
  receiverPartner,
}: Props) => {
  const { title, description } = useOtherPartnerBlockingCopy({
    isCurrentPartnerReceiver,
    senderPartner,
    receiverPartner,
  });

  return (
    <Alert withoutIcon severity="neutral" fullWidth className="max-h-72 overflow-y-auto">
      <AlertSection severity="neutral" title={title}>
        {description}
      </AlertSection>
    </Alert>
  );
};
